// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: true,
  version: env.mifos_x.version,
  hash: env.mifos_x.hash,
  // For connecting to server running elsewhere update the tenant identifier
  fineractPlatformTenantId: window['env']['fineractPlatformTenantId'] || 'uat_default',
  fineractPlatformTenantIds: window['env']['fineractPlatformTenantIds'] || 'uat_default',
  // For connecting to others servers running elsewhere update the base API URL
  baseApiUrls: window['env']['fineractApiUrls'] || '',
  // For connecting to server running elsewhere set the base API URL
  baseApiUrl: 'https://fineract-uat-api-server.indiagiftsgold.com',
  baseSchedulerUrl: 'https://fineract-uat-scheduler.indiagiftsgold.com',
  allowServerSwitch: false,
  apiProvider: window['env']['apiProvider'] || '/fineract-provider/api',
  apiVersion: window['env']['apiVersion'] || '/v1',
  serverUrl: '',
  oauth: {
    enabled: false,  // For connecting to Indiagold LMS using OAuth2 Authentication change the value to true
    serverUrl: ''
  },
  defaultLanguage: window['env']['defaultLanguage'] || 'en-US',
  supportedLanguages: window['env']['supportedLanguages'] || 'en-US,es-MX,fr-FR',
  preloadClients: window['env']['preloadClients'] || true,
  environment: 'UAT'
};

// Server URL
environment.serverUrl = `${environment.baseApiUrl}${environment.apiProvider}${environment.apiVersion}`;
environment.oauth.serverUrl = `${environment.baseApiUrl}${environment.apiProvider}`;
